import React           from 'react';
import { Translate }   from 'react-localize-redux';
import styled, { css } from 'styled-components';
import ImgTop          from './images/Reword.png';
import Section         from './section';
import titleImg        from './images/title/Reword.png';

const Image = styled.img`
  margin-top: 5vw;
  margin-left: 12vw;
  width: 75vw;
`;

/**
 * HowToPlay section<ImageContainer>
 */
const HowToPlay = () => {
  return (
    <>
      <Section imgSrc={titleImg} />
      <Image src={ImgTop} />
    </>
  );
};

export default HowToPlay;
